import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@mui/styles';
import { 
  Box, 
  CircularProgress,
  Grid, 
  IconButton, 
  Paper,
  Typography
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { CloseButton } from './styled';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    top: 0,
    zIndex: 1000,
    position: 'sticky',
  },
  rootLoading: {
    display: 'flex',
    paddingLeft: 220,
    paddingTop: 450,
  },
  drawerTitle: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.87)',
    textTransform: 'uppercase',
    lineHeight: 1.75,
    marginLeft: theme.spacing(1),
  },
}));

export const DetailPopup = ({ open, onClose, insideCard, children, width, title, loading, headerColor = '#E0E0E0' }) => {
  if (!open) return null;

  const [variableWidth, setVariableWidth] = React.useState(width);
  const [isMinified, setIsMinified] = React.useState(false);
  const originalWidth = width;
  const classes = useStyles();

  const handleMinify = () => {
    if (isMinified) {
      setVariableWidth(originalWidth);
      setIsMinified(false);
    } else {
      setVariableWidth('40px');
      setIsMinified(true);
    }
  };
  
  return (
    <Container>
      {
        loading &&
        <DetailContainer key="detail" width={variableWidth || '60%'}>
          <div className={classes.rootLoading}>
            <CircularProgress />
          </div>
        </DetailContainer>
      }
      {
        !insideCard && !loading &&
        <>
          <DetailContainer key="detail" width={variableWidth || '60%'}>
            <div className={classes.root}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{background: headerColor}}
              >
                {/*<Grid item xs={1}>
                  <IconButton onClick={handleMinify} isMinified={isMinified} style={{ color: "#fff" }}>
                    {isMinified ? <ChevronLeftIcon /> : <ChevronRightIcon /> }
                  </IconButton>
                </Grid>*/}
                {
                  !isMinified &&
                  <>
                    <Grid item xs={11}>
                      <Typography className={classes.drawerTitle} noWrap>
                        {title}
                      </Typography>
                    </Grid>
                    <Grid item xs={1} style={{ textAlign: 'right' }}>
                      <IconButton onClick={onClose} style={{ color: '#fff' }}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </>
                }
              </Grid>
            </div>
            <Detail isMinified={isMinified} >{ children }</Detail>
          </DetailContainer>
        </>
      }
      {
        insideCard && !loading &&
        <DetailContainerInsideCard key="detail">
          <Detail>{ children }</Detail>
          <CloseButton onClick={onClose}/>
        </DetailContainerInsideCard>
      }
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: position;
  top: 0px;
  left: 0px;
  border-top: 0;
`;

const OpacityBackground = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: grey;
  opacity: 0.8;
  display: ${props => props.isMinified ? 'none' : 'block'};
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 10px;
  display: ${props => props.isMinified ? 'none' : 'block'};
`;

const DetailContainer = styled(Paper)`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: ${props => props.width};
  overflow-y: auto;
  z-index: 1000;
`;

const DetailContainerInsideCard = styled(Paper)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  overflow-y: auto;
  z-index: 1000;
`;

const MinifyButtonContainer = styled.div`
  position: absolute;
  top: 5px;
  right: ${props => props.isMinified ? 0 : 480 };
`;

const Detail = styled(Box).attrs({
  p: { sm: 2, md: 3 },
})`
  position: relative;
  height: auto;
  display: ${props => props.isMinified ? 'none' : 'block'};
  padding: 0 !important;
`;